import { useIntlModule } from 'utils/intl';
import messages from './timeoutDialog.intl.json';

export function useTimeoutDialogIntl() {
  return useIntlModule(messages);
}
